module.exports = __webpack_public_path__ + "static/media/bpmeasurex-carrying-case-1.539afb47.png";